export default __webpack_public_path__ + "static/media/AM2 Logo Colour Light icon.598ba613.png";